import { render, staticRenderFns } from "./ClearBankSlip.vue?vue&type=template&id=5b6fe268&scoped=true"
import script from "./ClearBankSlip.vue?vue&type=script&lang=ts"
export * from "./ClearBankSlip.vue?vue&type=script&lang=ts"
import style0 from "./ClearBankSlip.vue?vue&type=style&index=0&id=5b6fe268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fe268",
  null
  
)

export default component.exports